import { urlpostfix, jsonpostfix } from "@/http/global.js";
import { post, getJSON } from "@/http/http.js";

/**
 *
 * @description
 *
 * */
// export function getDeedsdatas(types) {
//   return getJSON(`${jsonpostfix}${types}/${types}.json`);
// }
export function getDeedsdatas(columnId, pageNum = 1, pageSize = 40) {
  var data = {
    columnId,
    pageNum,
    pageSize
  };

  return post(`${urlpostfix}api/basic/getBasic`, data);
}

/**
 *
 * @description  烈士纪念设施分布
 *
 *
 * */
export function getdistribution() {
  return getJSON(`${jsonpostfix}cemetery/distribution/distribution.json`);
}

/**
 *
 * @description  烈士英明录 烈士数量/已被守护次数
 *
 *
 * */
export function getmartyrsnum(data) {
  // return post(`${urlpostfix}api/wsjs/census/list`, data);
}
/**
 *
 * @description  访问量接口
 *
 *
 * */
export function censusnum() {
  // return post(`${urlpostfix}census`);
}



// WEBPACK FOOTER //
// ./src/api/index.js